import React, { useEffect, useState } from 'react';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import { useNavigate } from 'react-router';
import {makeStyles } from '@material-ui/core';
import { Box, FormControl, Grid, Paper, TextField, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Spacer from '../../../components/Spacer';
import DownloadIcon from '@mui/icons-material/Download';
import { DataGrid } from '@material-ui/data-grid';
import MissionTransportService from '../../../services/MissionTransportService';
import { exportToExcel } from '../../../helpers/ExportHelpers';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import IndemnityMissionService from '../../../services/IndemnityMisisonService';
import Title from '../../../components/Title';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    width: "80vw",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));


const IndemnityMissionTable = () => {  
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(true);
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState({
        destination: '',
        debut: '',
        fin: '',
        status: ''
      });
     const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
      });
      const { open, color, messageInfo } = message;
      const classes = useStyles();
      const navigate = useNavigate();
    
      useEffect(() => {
        const fetchData = async () => {
          IndemnityMissionService.getAllIndemnityMissions().then((result) => {
            if (result && result.data) {
              const rowsToSet = result.data.map((row) => ({
                ...row,
                id: row.mission_planning_id, 
              }));
              
              setRows(rowsToSet);
              setOpenLoadingSimpleBackdrop(false);
            } else {
              setOpenLoadingSimpleBackdrop(false);
            }
          });
    
        };
        fetchData();
      }
        , []);

      function handleCloseMessage() {
        setMessage({ ...message, open: false });
      }
    
      const handleFilter = () => {
        setOpenLoadingSimpleBackdrop(true);
        MissionTransportService.filterPlanningValidated(filter).then((result) => {
          console.log(result);
          if (result && result.data) {
            setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
            setOpenLoadingSimpleBackdrop(false);
          } else {
            setOpenLoadingSimpleBackdrop(false);
          }
        });
      };

      const handleExportMissionToExcel = () => {
          let fileName = "missions_transport_" + new Date().toLocaleDateString() + ".xlsx";
          exportToExcel(rows, columns, fileName);
        }

        const handleChangeFilter = (e) => {
            const { name, value } = e.target;
            console.log(name, value);
            setFilter({ ...filter, [name]: value });
          }
    
  const columns = [
    { field: 'reference', headerName: 'Réference', width: 160 },
    { field: 'mission_title', headerName: 'Objet de la mission', width: 340 },
    { field: 'lieu', headerName: 'Destination', width: 160 },
    {
      field: 'users', headerName: 'Missionnaires', width: 400, renderCell: (params) => {
        return (
          <ul>
            {/* {params.row?.users.map((missionnary, index) => (
              <li><Typography key={index} sx={{ fontSize: '12px !important' }}>
                {missionnary.nom}
              </Typography></li>
            ))} */}
          </ul>
        );
      }
    },
    {
      field: 'date_begin', headerName: 'Date de début', width: 180, renderCell: (params) => {
        return (
          <>
            {new Date(params.row.date_begin).toLocaleDateString()}
          </>
        );
      }
    },
    {
      field: 'date_end', headerName: 'Date de fin', width: 160, renderCell: (params) => {
        return (
          <>
            {new Date(params.row.date_end).toLocaleDateString()}
          </>
        );
      }
    },
    {
      field: 'action', headerName: 'Action', width: 150, renderCell: (params) => {
        return (
          <strong>
            <Button title="Gérer les indemnités des missionnaires" onClick={() => navigate(`/accouting/mission_indemnity/add/${params.row.id}`)}>
              <AccountBalanceWalletIcon style={{ color: "grey" }} />
            </Button>
          </strong>
        );
      },
    }
  ];

    return (
       <>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 3 }}>
        <Grid container xs={12} spacing={4} justifyContent={"flex-end"} >
          <Button
            variant="contained"
            onClick={handleExportMissionToExcel}
            className={classes.btn}
            style={{ backgroundColor: 'darkgreen', color: 'white' }}
            startIcon={<DownloadIcon />}
          >
            EXPORT EXCEL
          </Button>
          <Spacer x={1} />
           <Button
            variant="contained"
            color="info"
            onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
        </Grid>
      </Box>

      <Grid container xs={12} spacing={2} >
        <Grid item xs={12} sm={6} md={3}>
            <label className={classes.labelPosition}>Réference:</label>
          <FormControl fullWidth variant="outlined" size="small">
          <TextField
            fullWidth
            id="reference"
            size="small"
            variant="outlined"
            value={filter.reference}
            name="reference"
          onChange={handleChangeFilter}
          />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Destination :
          <TextField
            fullWidth
            id="destination"
            size="small"
            variant="outlined"
            value={filter.destination}
            name="destination"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Date début:
          <TextField
            fullWidth
            id="date_debut"
            size="small"
            variant="outlined"
            type="date"
            value={filter.debut}
            name="debut"
          onChange={handleChangeFilter}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          Date fin:
          <TextField
            fullWidth
            id="date_fin"
            size="small"
            variant="outlined"
            type="date"
            value={filter.fin}
            name="fin"
          onChange={handleChangeFilter}
          />
        </Grid>

      </Grid>
      <Paper className={classes.paper} variant="outlined">
                  <Title>Elaboration timesheet</Title>
        <div style={{ height: "90vh", width: '100%' }}>
          <DataGrid rows={rows} columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50]}
            pagination
            paginationMode="server"
            disableSelectionOnClick />
        </div>
      </Paper>

       </>
    );
}

export default IndemnityMissionTable;